import { render, staticRenderFns } from "./TableColumnActive.vue?vue&type=template&id=2605a2a2&"
import script from "./TableColumnActive.vue?vue&type=script&lang=js&"
export * from "./TableColumnActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports